import type { ReactNode } from "react";

import { Label, type ButtonProps } from "react-aria-components";

import { Tooltip } from "#components/Tooltip";
import { InfoIcon } from "#icons";
import { cn } from "#utils";

export interface FormFieldHeaderProps {
  label?: ReactNode;
  tooltipText?: ReactNode;
  isDisabled?: boolean;
  isRequired?: boolean;
  labelClassName?: string;
  labelProps?: React.ComponentPropsWithoutRef<typeof Label>;
  tooltipButtonProps?: ButtonProps;
}

export function FormFieldHeader({
  label,
  tooltipText,
  isDisabled,
  isRequired,
  labelClassName,
  labelProps,
  tooltipButtonProps,
}: FormFieldHeaderProps) {
  if (!label && !tooltipText) {
    return null;
  }

  return (
    <div className="flex items-center justify-between gap-x-3">
      {label ? (
        <div className="flex items-center">
          <Label
            className={cn(
              "text-label-small text-text-secondary",
              isDisabled ? "text-text-disabled" : "",
              labelClassName,
            )}
            {...labelProps}
          >
            {label}
          </Label>
          {isRequired ? (
            <span
              aria-hidden="true"
              className={cn(
                "ml-0-5 text-label-small text-foreground-negative",
                isDisabled ? "text-text-disabled" : "",
              )}
            >
              *
            </span>
          ) : null}
        </div>
      ) : null}
      {tooltipText ? (
        <Tooltip buttonProps={tooltipButtonProps} title={tooltipText}>
          <InfoIcon
            className={cn(
              "size-lg text-foreground-secondary",
              isDisabled ? "text-text-disabled" : "",
            )}
          />
        </Tooltip>
      ) : null}
    </div>
  );
}
